var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "frame", staticClass: "viewer-website", attrs: { tabindex: "-1" } },
    [
      _vm.getIsYouTube
        ? _c("div", { staticClass: "youtube-player", attrs: { id: "player" } })
        : _c("iframe", {
            ref: "iframe",
            staticClass: "viewer-website__website",
            attrs: { src: _vm.getUrl(_vm.src), tabindex: "-1" }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bb140f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bb140f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebViewer.vue
// module id = null
// module chunks = 